import React from "react";

const Footer = () => {
  return (
    <footer className="site-footer">
      <span>bsf9090 | Powered By BSF Gaming | Copyright © 2019-2026</span>
    </footer>
  );
};

export default Footer;


